/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeatureFlagName } from '../models/FeatureFlagName';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeatureApiService {
    /**
     * Returns list of available features
     * @returns FeatureFlagName List of available features
     * @throws ApiError
     */
    public static getAvailableFeatures({
        creatorId,
    }: {
        /**
         * Id of the creator chatter currently working with
         */
        creatorId: number,
    }): CancelablePromise<Array<FeatureFlagName>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/feature/available/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
        });
    }
}
